import React, { FunctionComponent, useContext, useState } from 'react'

interface Filter {
  mobillyClientId: number | ''
  plateNumber: string
}

type RootState = {
  filter: Filter
  loadList: number
  listLoading: boolean
  listPerPage: number
  listPage: number
}

type RootFunctions = {
  setLoadList(): void
  setListLoading(status: boolean): void
  setListPage(value: number): void
  onFilter(filter: Filter): void
  onChangePerPage(perPage: number): void
  onChangePage(page: number): void
}

const InitialState: RootState = {
  filter: {
    mobillyClientId: '',
    plateNumber: '',
  },
  loadList: 0,
  listLoading: false,
  listPerPage: 20,
  listPage: 1,
}

export const CustomerNotificationExclusionsContext = React.createContext<[RootState, (state: any) => void]>([InitialState, () => {
}])

export const CustomerNotificationExclusionsProvider: FunctionComponent = ({ children }) => {
  const [state, setState] = useState<RootState>(InitialState)

  return (
    <CustomerNotificationExclusionsContext.Provider value={[state, setState]}>
      {children}
    </CustomerNotificationExclusionsContext.Provider>
  )
}

export const useCustomerNotificationExclusions = (): RootFunctions & RootState => {
  const [state, setState] = useContext(CustomerNotificationExclusionsContext)

  const setLoadList = () => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
    }))
  }

  const setListLoading = (status: boolean) => {
    setState((state: RootState) => ({
      ...state,
      listLoading: status,
    }))
  }

  const setListPage = (value: number) => {
    setState((state: RootState) => ({
      ...state,
      listPage: value,
    }))
  }

  const onFilter = (filter: Filter) => {
    setState((state: RootState) => ({
      ...state,
      filter,
      loadList: state.loadList + 1,
      listPage: 1,
    }))
  }

  const onChangePerPage = (perPage: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPerPage: perPage,
      listPage: 1,
    }))
  }

  const onChangePage = (page: number) => {
    setState((state: RootState) => ({
      ...state,
      loadList: state.loadList + 1,
      listPage: page,
    }))
  }

  return {
    setLoadList,
    setListLoading,
    setListPage,
    onFilter,
    onChangePerPage,
    onChangePage,
    ...state,
  }
}
